import { createContext, useContext } from 'react';

const defaultValue = { isOpen: false, open: () => null };

export const NotAcceptingOrdersContext = createContext(defaultValue);
export const useNotAcceptingOrdersHandler = () =>
  useContext(NotAcceptingOrdersContext);
